import React, { memo } from 'react'
import Image from 'next/image'
import cn from 'classnames'
import Link from 'next/link'

import Button from '@/components/mawooButton'
import { PhoneIcon } from '@/components/icons'

import s from './How.module.scss'

const steps = [
  {
    icon: '/home/search.svg',
    title: 'Find your perfect puppy',
    text: (
      <>
        Search by breed, location, size, and more. Use our{' '}
        <Link href="/dog-breed-quiz"> Puppy Match Quiz</Link> or call our puppy
        concierge for personalized assistance.
      </>
    ),
    alt: 'Search icon with a heart icon in its center',
  },
  {
    icon: '/home/reserve.svg',
    title: 'Reserve your puppy',
    text: 'Found the one? Fill out the reservation form and complete your payment to secure your puppy.',
    alt: 'Clipboard with a checkmark next to it',
  },
  {
    icon: '/home/carry.svg',
    title: 'Welcome your puppy',
    text: 'We will reach out to arrange the delivery or pickup of your puppy. Get ready to welcome your new furry friend into your home!',
    alt: 'Travel crate with a heart icon in its center',
  },
]

export default memo(function How() {
  return (
    <div className={s.how}>
      <h2>How Does Mawoo Pets Work?</h2>

      <div className={s.steps}>
        {steps.map((step, index) => (
          <div key={index} className={s.step}>
            <div className={s.iconContainer}>
              <Image
                src={step.icon}
                className={s.icon}
                width={95}
                height={80}
                alt={step.alt}
              />
            </div>

            <div className={s.text}>
              <p className={s.text__title}>{step.title}</p>
              <p>{step.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={s.call}>
        <h2>Need Assistance?</h2>
        <p className={s.call_date}>We’re here Mon-Sat, 9AM - 9PM ET!</p>
        <div className={s.buttons}>
          <Button
            variant="secondary-outline"
            className={cn(s.btn)}
            onClick={() => window.open('tel:1-888-488-7203')}
          >
            <PhoneIcon className={s.btn_icon} width={24} height={26} /> Call: 1
            (888) 488-7203
          </Button>
        </div>
      </div>
    </div>
  )
})
